import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = { class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1" }
const _hoisted_12 = { href: "#" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = { class: "btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3" }
const _hoisted_15 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_16 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_17 = { class: "d-flex flex-wrap" }
const _hoisted_18 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 text-center" }
const _hoisted_19 = { class: "fw-bold fs-6 text-gray-400 mb-2" }
const _hoisted_20 = { class: "d-flex align-items-center text-center justify-content-center" }
const _hoisted_21 = { class: "svg-icon svg-icon-success me-2" }
const _hoisted_22 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_23 = { class: "fs-9" }
const _hoisted_24 = { class: "d-flex overflow-auto h-55px py-3" }
const _hoisted_25 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_26 = { class: "nav-item nav-line-tabs" }
const _hoisted_27 = { class: "nav-item nav-line-tabs" }
const _hoisted_28 = { class: "nav-item nav-line-tabs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.user.picture,
                alt: "image"
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.user.first_name + " " + _ctx.user.last_name), 1),
                  _createElementVNode("a", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                    ])
                  ]),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.user.type), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.translate("my wallet")), 1),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/finance/fin008.svg" })
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createTextVNode(_toDisplayString(Number(_ctx.user.credit).toLocaleString()) + " ", 1),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.translate("toman")), 1)
                      ])
                    ]),
                    _createVNode(_component_router_link, {
                      to: "/credit-charge",
                      class: "btn btn-primary mt-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Recharge wallet")), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("ul", _hoisted_25, [
            _createElementVNode("li", _hoisted_26, [
              _createVNode(_component_router_link, {
                to: "/settings/overview",
                class: "nav-link text-active-primary text-gray-700 me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("my profile")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_27, [
              _createVNode(_component_router_link, {
                "data-testid": "edit-profile-tabs",
                to: "/settings/settings",
                class: "nav-link text-active-primary text-gray-700 me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("edit profile")), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_28, [
              _createVNode(_component_router_link, {
                to: "/settings/credit",
                class: "nav-link text-active-primary text-gray-700 me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("My wallet changes")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}